import { fetchFromAPI } from 'utils/api';

export const postCloudfrontCookies = (params) => {
  const options = {
    method: 'post',
    credentials: 'include',
  };

  if (params) {
    options.body = JSON.stringify(params);
  }

  return fetchFromAPI('/cloudfront/cookies', options);
};
